export enum ItemCondition {
  NEW = 'NEW',

  USED = 'USED',
}
